import React, { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess } from "services/toast.service";
import { handleError, getAccessToken } from "utils";
import { useHistory, useLocation } from "react-router-dom";
import Button from "components/Button";
import { API_BASE_URL } from "config/constants";
import Modal from "react-modal";
import { getUser } from "utils";

// components

const AddAccounts = ({ color }) => {
  const { pathname, state } = useLocation();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [manager, setmanager] = useState([]);

  const [assignedManager, setassignedManager] = useState({
    assign: "",
  });
  const [gettingData, setGettingData] = useState(false);
  const user = getUser();

  const { data } = state || {};
  const isUpdate = pathname === "/admin/update-account";
  const history = useHistory();

  if (isUpdate && !data) {
    history.goBack();
  }
  const [approveid, setapproveid] = useState();

  const [submitClick, setSubmitClick] = useState(false);
  const [loading, setLoading] = useState(false);

  const [account, setAccount] = useState(
    data || {
      name: "",
      manager: "",
      email: "",
      phone: "",
      shippingAddress: "",
      billingAddress: "",
    }
  );

  const onChange = (e) => {
    setAccount({ ...account, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    if (!account.name || !account.manager || !account.email || !account.phone)
      return false;
    return true;
  };

  const handleClick = () => {
    setSubmitClick(true);
    if (!isValid()) return;
    if (isUpdate) {
      updateClient(account);
    } else {
      addAccount(
        account.name,
        account.manager,
        account.email,
        account.phone,
        account.shippingAddress,
        account.billingAddress
      );
    }
  };

  const onapp = (e) => {
    setassignedManager({ ...assignedManager, [e.target.name]: e.target.value });
  };

  const getManagers = async () => {
    try {
      setGettingData(true);
      const response = await axios.get(
        `${API_BASE_URL}/user/all_account_managers`,
        {
          method: "GET",
          headers: {
            authorization: getAccessToken(),
          },
        }
      );
      setGettingData(false);
      const apiData = response.data;
      setmanager(apiData.result.data);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  console.log(manager);
  useEffect(() => {
    getManagers();
  }, []);

  const addAccount = async (
    name,
    manager,
    email,
    phone,
    shippingAddress,
    billingAddress
  ) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/account`,
        {
          name,
          manager,
          email,
          phone,
          shippingAddress,
          billingAddress,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/accounts");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const updateClient = async (dataToUpdate) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${API_BASE_URL}/account`,
        {
          id: data._id,
          ...dataToUpdate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/accounts");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const ApproveId = (ids) => {
    const id = ids;
    setapproveid(id);
  };
  console.log(approveid);

  const Approved = async (assignedManager) => {
    const datas = JSON.parse(assignedManager);
    try {
      const response = await axios.post(
        `https://pmpmedia-api.herokuapp.com/api/v1/user/approve`,
        {
          id: approveid,
          assignedTo: datas.name,
          assignedToId: datas._id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      console.log(response, "res");
    } catch (error) {
      console.log(error);
    }
  };

  const customStyles = {
    content: {
      top: "40%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const modal = () => {
    setIsOpen((current) => !current);
  };

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">
              {isUpdate ? "Update Account" : "Add New Account"}
              <span className="text-blueGray-700 text-sm font-bold">
                {" "}
                (Fill in the details below)
              </span>
            </h6>

            {/* {isUpdate ? (
              <>
                <button
                  className="bg-orange-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => {
                    ApproveId(account._id);
                    modal();
                  }}
                >
                  Approve
                </button>
              </>
            ) : (
              ""
            )} */}
          </div>
        </div>
        <div className="flex-auto px-4 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase px-4">
              Account Information
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Account Name
                  </label>
                  <input
                    type="text"
                    value={account.name}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="name"
                    onChange={onChange}
                  />
                  {submitClick && !account.name && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Account Name is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Account Manager
                  </label>

                  {manager && manager[0] && (
                    <>
                      {user.role === "Admin" ? (
                        <select
                          onChange={onChange}
                          name="manager"
                          value={account.manager}
                          className="border-0 mt-1 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        >
                           <option value={""}>
                              Choose account manager..
                            </option>
                          {manager.map((item, key) => (
                            <option key={key} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div>{account.manager}</div>
                      )}
                    </>
                  )}
                  {submitClick && !account.name && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Account Manager is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Account Email
                  </label>
                  <input
                    type="email"
                    value={account.email}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="email"
                    onChange={onChange}
                  />
                  {submitClick && !account.name && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Account Email is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Account Phone
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={account.phone}
                    name="phone"
                    onChange={onChange}
                  />
                  {submitClick && !account.phone && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Account Phone is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Billing Address
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={account.billingAddress}
                    name="billingAddress"
                    onChange={onChange}
                  />
                  {/* {submitClick && !account.billingAddress && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Billing Address is required!
                    </div>
                  )} */}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Shipping Address
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={account.shippingAddress}
                    name="shippingAddress"
                    onChange={onChange}
                  />
                  {/* {submitClick && !account.shippingAddress && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Shipping Address is required!
                    </div>
                  )} */}
                </div>
              </div>
            </div>
            <div className="px-4">
              <Button
                title={isUpdate ? "UPDATE ACCOUNT" : "ADD NEW ACCOUNT"}
                handleClick={handleClick}
                loading={loading}
              />
            </div>
          </form>

          <div>
            <Modal
              isOpen={modalIsOpen}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="rounded-t mb-0 px-4 py-3 border-0 ">
                <div className="flex flex-wrap items-center">
                  <div className="relative flex justify-items-start gap-2 items-center w-full px-6 max-w-full flex-grow flex-1">
                    {" "}
                    <h3
                      className={
                        "font-semibold text-lg  " +
                        (color === "light" ? "text-blueGray-700" : "text-black")
                      }
                    >
                      Need for Approval
                    </h3>
                  </div>

                  <i
                    className="fa fa-times-circle h-4 w-5 ml-5 mb-6"
                    onClick={closeModal}
                  ></i>
                </div>
              </div>
              <div className="w-full lg:w-6/20 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Assigned To
                  </label>
                  <select
                    value={manager.name}
                    name="assign"
                    onChange={onapp}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    <option value="">Choose Role</option>
                    {manager.map((n, index) => (
                      <option key={index} value={JSON.stringify(n)}>
                        {n.name}
                      </option>
                    ))}
                  </select>

                  <button
                    className=" mt-2 bg-yellow-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => Approved(assignedManager)}
                  >
                    Approved
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAccounts;
